import type {
	RoutingGuideEnumItem,
	RoutingGuideEnumsType,
} from "~/shared/schemas/routing-guide-schema.ts";

export const getOperators = (
	selectorName: string,
	enums: RoutingGuideEnumsType | undefined,
): RoutingGuideEnumItem[] => {
	const allSelectors = [
		...(enums?.ifFieldSelectors ?? []),
		...(enums?.thenFieldSelectors ?? []),
	];
	const selector = allSelectors.find((s) => s.name === selectorName);
	if (!selector) return [];
	return (enums?.operators ?? []).filter((op) =>
		selector.operators.includes(op.value),
	);
};
